import React from "react";
import styled from "styled-components";
import Image from "../ui/Image";
import FileUploader from "../ui/FileUploader";

const FormRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 140px;
  gap: 24px;
  align-items: start;
  width: 100%;

  @media only screen and (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
`;

const FieldLabel = styled.span`
  color: #18233b;
  font: 700 14px/1.2 Poppins, sans-serif;
`;

const PreviewImage = styled(Image)`
  width: 99px;
  border: 1px solid #d4d4d5;
  border-radius: 4px;
`;

export const UploadLogoForm = ({
  uploadButtonLabel,
  uploadDescription,
  uploadLabel,
  previewLabel,
  logo,
  uploadLogo,
  proshop,
}) => {
  return (
    <FormRow>
      <SectionContainer>
        <FieldLabel>{uploadLabel}</FieldLabel>
        <FileUploader
          label={uploadButtonLabel}
          handleFile={(base64) => {
            uploadLogo({ imageBase64: base64, proshop });
          }}
        />
      </SectionContainer>
      <SectionContainer>
        <FieldLabel>{previewLabel}</FieldLabel>
        <PreviewImage
          src={logo}
          fluid={"true"}
          alt={""}
          placeholderSrc={""}
        />
      </SectionContainer>
    </FormRow>
  );
};

// export const UploadLogoForm = connect(
//   (state) => {
//     console.log("previes call settings", state);
//     return {
//       // requesting: state.userSession.requesting,
//       // error: state.userSession.error,
//       initialValues: state.userSession.userData,
//       // initialLanguage: state.userSession.userData.preferred_lang,
//       // enableReinitialize: true,
//       // remoteSyncing: state.spectreApp.deviceInfo,
//     };
//   }, {}
//   // { settingsRestoreBackup, settingsSaveBackup }
// )(UploadLogoRedux);
